module.exports = __webpack_public_path__ + "static/media/icon-pending.5586dab5.svg";